import { defineStore } from 'pinia'

export const useHistoryStore = defineStore('bestdealer-history', () => {
  const list = ref([])

  const insert = (item) => {
    const index = list.value.findIndex(i => i.offerId === item.offerId)
    if (index > -1) {
      list.value.splice(index, 1)
    } else if (list.value.length >= 50) {
      list.value.pop()
    }
    list.value.unshift(item)
  }

  const clear = () => {
    list.value = []
  }

  return { list, insert, clear }
}, {
  persist: true,
  sync: true
})
